import { SchemaField } from '../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

export class ConversationFilterResultSchema extends SerializableObjectSchema {
  public static readonly spamDetected = 'spamDetected';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly spamDetected = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    parameters[ConversationFilterResultSchema.spamDetected] = SchemaField.boolean(
      ConversationFilterResultSchema.Defaults.spamDetected,
    );

    return parameters;
  }
}
